<template>
	<div class="app-container terms-wrapper">
		<LogoHeader v-if="isPublic && !inModal" :position="'left'" :isLink="true"/>
		<h1>{{ article.title }}</h1>
		<div class="content" v-html="article.html"></div>
		<ErrorAlert v-if="error" :error="error" />
		<Spinner v-if="loading" />
	</div>
</template>

<script>
import Article from '../../services/article';
import Spinner from '../../components/shared/Spinner';
import ErrorAlert from '../../components/shared/ErrorAlert';
import LogoHeader from '../../components/shared/LogoHeader';

export default {
	name: 'Terms',
	props: ["inModal"],
	components: {
		ErrorAlert,
		Spinner,
		LogoHeader,
	},
	data() {
		return {
			article: {},
			error: null,
			loading: false,
			isPublic: false,
		};
	},
	mounted() {
		this.getTermsAndConditions();
		if (this.$route.meta.isPublic && !this.checkIfSession()) {
			this.isPublic = true;
		} else {
			this.isPublic = false;
		}
	},

	methods: {
		getTermsAndConditions() {
			this.loading = true;
			Article.instance()
				.getTermsAndConditions()
				.then((res) => {
					this.article = res.data;
					this.loading = false;
				})
				.catch((err) => {
					this.error = err;
					this.loading = false;
				});
		},
		checkIfSession: function () {
			return !!window.localStorage.getItem('access_token');
		},
	},
};
</script>

<style scoped>
.terms-wrapper {
	height: calc(100% - 60px);
	overflow: auto;
}
.content {
	width: 100%;
	max-width: 87.5rem;
}
</style>